// MESSAGING-READINESS-TRUTH-01 — which quotation the payment chain runs on.
//
// `quotes[0]` was whatever the quote list happened to return first, so the
// Messages readiness bar could judge an old version, an unselected alternative
// or a clinic-internal DRAFT instead of the ACCEPTED offer the patient paid
// against. Order of truth: ACCEPTED → current issued version → none.
// A DRAFT is never a payment candidate — it was never sent.
export const selectPayableThreadQuote = (rows) => {
  const quotes = (rows || []).filter(
    (q) => String(q.status || '').toUpperCase() !== 'DRAFT');
  const accepted = quotes.find(
    (q) => String(q.status || '').toUpperCase() === 'ACCEPTED');
  return accepted || quotes.find((q) => q.is_latest) || quotes[0] || null;
};

export default selectPayableThreadQuote;
